import { Theme } from '@core/models/theme.model';
import { createAction, props } from '@ngrx/store';

export const enter = createAction('[App Page] Enter');

export const updateTheme = createAction(
  '[App Page] Update theme',
  props<{ theme: Theme }>()
);
